import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DELIVERY_TYPES } from '../../library/constants/constants.js';
import { formatPrice, getCmsFileUrl } from '../../library/utilities';
import ProductImageWithNote from './product-image-with-note';
import styles from './quotation-item-preview.module.scss';

const QuotationItemPreview = ({ item, currency }) => {
    const { t } = useTranslation()

    return (
        <div className={`box box--light-gray ${styles.wrapper}`}>
            <div className="box--small">
                <h3>{t('Item Name')}</h3>
                <h2>{item.product.name}</h2>
            </div>
            <div className={styles.item}>
                <div className={styles.left}>
                    <div className="box box--dark-gray">
                        <ProductImageWithNote
                            className={styles.image}
                            noteAs="p"
                            src={item.product.photos && getCmsFileUrl(item.product.photos[0])}
                        />
                    </div>
                </div>
                <div className={styles.right}>
                    <div className="box box--dark-gray">
                        <h2>{t('Specifications')}</h2>
                        <div className={styles.specifications}>
                            {item.specifications.map(({ name, value }) => (
                                <React.Fragment key={name}>
                                    <div className={styles.name}>{name}</div>
                                    <div className={styles.value}>{value}</div>
                                </React.Fragment>
                            ))}
                            {item.item_hidden_specification?.map(({ name, value }) => (
                                <React.Fragment key={name}>
                                    <div className={styles.name}>{name}</div>
                                    <div className={styles.value}>{value}</div>
                                </React.Fragment>
                            ))}
                        </div>
                        <hr />
                        <div className={styles.quantities}>
                            <div className={`${styles.quantityHeading} ${styles.quantityRow}`}>
                                <div>{t('Quantity')}</div>
                                <div>{t('Sales Price/Piece')}</div>
                                <div>{t('Total Amount')}</div>
                            </div>
                            <div className={styles.quantityRow} key={item.price.id}>
                                <div>{item.price.quantity}</div>
                                <div>{formatPrice(item.price.sales_price, currency.code)}</div>
                                <div>{formatPrice(item.price.total_price_excl_vat, currency.code)}</div>
                            </div >
                        </div>
                    </div>
                    <div className="box box--dark-gray">
                        <h4>{t("Delivery")}</h4>
                        {item.delivery_type === DELIVERY_TYPES.MULTIPLE ? (
                            <p className='nomargin'>{t("Registered {{delivery_count}} deliveries to {{countries}}", { delivery_count: item.item_delivery_addresses?.length, countries: item.item_delivery_addresses?.map(({ country }) => country?.name)?.join(', ') })}</p>
                        ) : item.delivery_type === DELIVERY_TYPES.BULK ? (
                            <p className='nomargin'>{t("Registered bulk delivery to multiple addresses")}</p>
                        ) : (
                            <p className='nomargin'>{t("Registered delivery to {{country}}", { country: item.item_delivery_addresses?.[0]?.country?.name })} </p>
                        )}
                        <p></p>
                        <h4>{t("Delivery Time")}</h4>
                        <p className='nomargin'>{t("{{time}} after approval of the proof. A shorter delivery time can be arranged", { time: item.expected_delivery_period })}.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

QuotationItemPreview.propTypes = {
    item: PropTypes.object.isRequired,
    currency: PropTypes.object.isRequired
}

export default QuotationItemPreview
